export default {"src":"/_next/static/media/close.5467b6f8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};